import { useGraphqlQuery } from "@mzara/component";
import { TAppointmentBoard } from "@mzara/graphql";
import _ from "lodash";
import { MindMapInvitationsQuery } from "../queries/MindMapInvitationsQuery";

export const useMindMapInvitationsQuery = (id: number, suspense?: boolean) => {

    return useGraphqlQuery<MindMapInvitationsQuery, TAppointmentBoard>(
        new MindMapInvitationsQuery({ id }), {suspense, enabled: id !== undefined});
};